// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"3dc5c9e2","12":"f3a2771c","120":"b127939a","172":"b5baa8bc","180":"18dce7ab","256":"d03c0b3c","476":"0c060a65","592":"6d7de513","672":"13bf88bc","756":"7d167e7b"}[chunkId] + ".chunk.js";
};